import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UserSvg } from "../svgFile";
import Login from "../components/client/auth/Login/Login";
import { useSelector, useDispatch } from "react-redux";
import { logoutUser } from "../redux/slices/authSlice";
import { removeFcmToken } from "../components/firebaseConfig";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [token, setToken] = useState(localStorage.getItem("accessToken"));
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    const checkToken = () => {
      const newToken = localStorage.getItem("accessToken");
      setToken(newToken);
    };

    window.addEventListener('storage', checkToken);

    window.addEventListener('focus', checkToken);

    return () => {
      window.removeEventListener('storage', checkToken);
      window.removeEventListener('focus', checkToken);
    };
  }, []);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleLogout = async () => {
     await removeFcmToken();
    dispatch(logoutUser());
    setToken(null);
  };

  const currentToken = token || localStorage.getItem("accessToken");

  return (
    <>
      <header
        className={`header 
        ${scrolled ? "header-scrolled" : ""} 
      `}
      >
        <nav className="navbar navbar-expand-xl navbar-dark container">
          <Link className="navbar-brand d-flex align-items-center" to="/">
            <img src="/image/logo.png" alt="Logo" />
          </Link>

          <div className="collapse navbar-collapse" id="navbarNavDropdown">
            <ul className="navbar-nav me-auto">
              <li className="nav-item">
                <a className="nav-link" href="#how-it-work">
                  How It Works
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#service">
                  Services
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#carrier">
                  Carriers
                </a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#testimonial">
                  Testimonial
                </a>
              </li>
            </ul>
          </div>

          <div className="d-flex align-items-center gap-4 text-white">
            {!currentToken ? (
              <>
                <Link
                  className="nav-link"
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#loginModal"
                >
                  <span className="me-2">
                    <UserSvg />
                  </span>
                  Sign In
                </Link>

                <Link
                  className="btn white-btn d-none d-md-block"
                  to="/signup"
                >
                  Get Started Free
                </Link>
              </>
            ) : (
              <>
                {/* <div className="position-relative" style={{ cursor: 'pointer' }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                  </svg>
                  <span
                    className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                    style={{ fontSize: '10px', padding: '3px 5px' }}
                  >
                    3
                    <span className="visually-hidden">notifications</span>
                  </span>
                </div> */}

                <div className="dropdown">
                  <button
                    className="btn btn-link nav-link dropdown-toggle d-flex align-items-center gap-2 p-0"
                    type="button"
                    id="userDropdown"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      textDecoration: 'none',
                      color: 'white'
                    }}
                  >
                    <span className="me-1">
                      <UserSvg />
                    </span>
                    <span className="d-none d-md-inline">
                      {user?.fullName?.split(' ')[0] || 'User'}
                    </span>
                  </button>
                  <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
                    <li>
                      <Link className="dropdown-item" to={user?.role === "SHIPPER" ? "/carrer-dashboard" : "/user-dashboard"}>
                        Dashboard
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/my-account">
                        My Profile
                      </Link>
                    </li>
                    <li><hr className="dropdown-divider" /></li>
                    <li>
                      <button
                        className="dropdown-item text-danger"
                        onClick={handleLogout}
                      >
                        Sign Out
                      </button>
                    </li>
                  </ul>
                </div>
              </>
            )}

            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNavDropdown"
              aria-controls="navbarNavDropdown"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon" />
            </button>
          </div>
        </nav>
      </header>
      <Login />
    </>
  );
}